import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForCustomerLeafCollectionReport } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { CustomerLeafCollectionReportSchemaObject } from "../CustomerLeafCollectionReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import { isNull, set } from "lodash";
import '../Pages/tableFooter.css';
import xlsx from 'json-as-xlsx';

const screenCode = "CUSTOMERLEAFCOLLECTIONREPORT";

export function CustomerLeafCollectionReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [collectionTypes, setCollectionTypes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [totalAmount, setTotalAmount] = useState([]);
    const [customerCount, setCustomerCount] = useState([]);
    const [totalAmountOfLeaf, setTotalAmountOfLeaf] = useState(0);
    const [bagCount, setbagCount] = useState([]);
    const [totalBagCount, setTotalBagCount] = useState(0);

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        collectionTypeID: "0",
        searchDate: "",
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        collectionType: "0",
        searchDate: "",
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [totalValues, setTotalValues] = useState({
        gross: 0,
        net: 0,
        deduction: 0,
        bagcount: 0
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(CustomerLeafCollectionReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["createdDate", "collectionPointName", "registrationNumber", "nameToBePrinted", "collectionTypeName", 
        "numberOfUnits", "totalAmount", "grossAmount", "totalDeduction"]

    const csvHeaders = [
        { label: "Leaf collected date", value: "createdDate" },
        { label: "Route name", value: "collectionPointName" },
        { label: "Customer reg. number", value: "registrationNumber" },
        { label: "Customer Name", value: "nameToBePrinted" },
        { label: "Narration", value: "narration" },
        { label: "Collection type", value: "collectionTypeName" },
        { label: "Bag count", value: "numberOfUnits" },
        { label: "Net total (Kg)", value: "totalAmount" },
        { label: "Gross total (Kg)", value: "grossAmount" },
        { label: "Total Deduction (Kg)", value: "totalDeduction" },
    ];

    const [reportData, setReportData] = useState([]);
    const [keys, setKeys] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown(),
            getCollectionTypesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0",
            collectionTypeID: "0",

        });
        clearTableRelatedData();

    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0",
            collectionTypeID: "0",
        });
        clearTableRelatedData();

    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
        clearTableRelatedData();

    }

    function handleCollectiontypeChange(target) {

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            collectionTypeID: target.value
        });
        clearTableRelatedData();

    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            searchDate: target.value,
        });
        clearTableRelatedData();

    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, CustomerLeafCollectionReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCUSTOMERLEAFCOLLECTIONREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }

    async function getCollectionTypesForDropDown() {
        const data = await services.getAllCollectionTypesByoperationEntityID(leafCollectionDetails.factoryID);
        setCollectionTypes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        destroyDataTable();
        setIsTableHide(true);
        setButtonHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        setIsTableHide(true);

        const result = await services.getCustomerLeafCollectionReportData(leafCollectionDetails);
        var totalRow = await calculateTotalData(result.reportData);
        setTotalValues(totalRow);

        result.reportData.forEach(x => {
            x.createdDate = x.createdDate.split('T')[0];
            x.narration = (isNull(x.narration) || x.narration === '') ? '-' : x.narration;
        });

        if (result.reportData.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }

        var total = 0;
        var bagtotal = 0;
        result.totalColectionTypes.forEach(x => {
            total = total + x.totalAmount;
            bagtotal = bagtotal + x.numberOfUnits;
        });
        setTotalAmountOfLeaf(total);
        setTotalBagCount(bagtotal);

        result.reportData.forEach(x => {
            x.createdDate = x.createdDate.split('T')[0];
        })

        setReportData(result.reportData);
        setTotalAmount(result.totalColectionTypes);
        setCustomerCount(result.customerCount);
        setbagCount(result.totalColectionTypes);
        createDataTable();

        setButtonHide(false);
        setIsReportButtonsEnabled();
        createDataTable();

        var csvResult = [
            {
                createdDate: "Total",
                numberOfUnits: totalRow.bagcount,
                totalAmount: totalRow.net,
                grossAmount: totalRow.gross,
                totalDeduction: totalRow.deduction,
            },
            {},
            {
                createdDate: "Summary",
                collectionPointName: "Customer Count",
                registrationNumber: result.customerCount,
                nameToBePrinted: "Bag Total",
                narration: bagtotal,
                collectionTypeName: "Total Collection Amount",
                numberOfUnits: total,
            }
        ];

        var csvDataWithTotal = [...result.reportData, ...csvResult];
        csvDataWithTotal.unshift({}, {
            createdDate: "Date: " + new Date().toLocaleString(),
            collectionPointName: "User: " + tokenService.getUserNameFromToken()
        }, {})

        setCsvData(csvDataWithTotal);
    }

    async function calculateTotalData(data) {
        let grosssum = data.reduce(function (prev, current) {
            return prev + +current.grossAmount
        }, 0);

        let netsum = data.reduce(function (prev, current) {
            return prev + +current.totalAmount
        }, 0);

        let deductionsum = data.reduce(function (prev, current) {
            return prev + +current.totalDeduction
        }, 0);

        let bags = data.reduce(function (prev, current) {
            return prev + +current.numberOfUnits
        }, 0);


        return {
            gross: grosssum,
            net: netsum,
            deduction: deductionsum,
            bagcount: bags
        }
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }



    function createFile() {
        var settings = {
            sheetName: 'Customer Leaf Collection Report',
            fileName: 'CustomerLeafCollectionReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            collectionTypeID: "0",
            searchDate: "",
        });
        setErrors("");
        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setIsTableHide(true);
        setIsReportButtonsEnabled(false);
        setReportData([]);
        setSelectedSearchValues([]);
        setKeys([]);
        setTotalAmount([]);
        setCustomerCount([]);
        setTotalAmountOfLeaf([]);
        setbagCount([]);
        setTotalBagCount([])
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            collectionType: collectionTypes[searchForm.collectionTypeID],
            date: searchForm.searchDate,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Customer Leaf Collection Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="">Collection type</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionTypeID"
                                            id="collectionTypeID"
                                            name="collectionTypeID"
                                            value={leafCollectionDetails.collectionTypeID}
                                            onChange={(e) => handleCollectiontypeChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection type--</MenuItem>
                                            {generateDropDownMenu(collectionTypes)}
                                        </Select>
                                        {errors["collectionTypeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionTypeID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="card pt-2 pl-3 pr-3" style={{ width: "10rem;" }}>
                                        <div className="card-header"><h6>Summary</h6></div>
                                        <div className="card-body">
                                            <p className="d-inline pr-3"><b>Customer count : </b> {customerCount} </p>

                                            {totalAmount.map((d, i) => {
                                                return (
                                                    <p key={i} className="pt-3 d-inline pr-3"><b>{d.collectionTypeName} : </b>{(d.totalAmount)} Kg</p>
                                                )
                                            })}

                                            <p className="d-inline pr-3"><b>Total Leaf Amount: </b> {totalAmountOfLeaf} Kg</p>

                                            {bagCount.map((d, i) => {
                                                return (
                                                    <p key={i} className="pt-3 d-inline pr-3"><b>{d.collectionTypeName} : </b>{(d.numberOfUnits)} bags</p>
                                                )
                                            })}
                                            <p className="d-inline pr-3"><b>Total Bag Count: </b> {totalBagCount} bags</p>

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="example" className="display dataTable no-footer">
                                                    <thead>
                                                        <tr>
                                                            <th>Leaf collected date</th>
                                                            <th>Route name</th>
                                                            <th>Customer reg. number</th>
                                                            <th>Custome Name</th>
                                                            <th>Collection type</th>
                                                            <th>Bag count</th>
                                                            <th>Net total (Kg)</th>
                                                            <th>Gross total (Kg)</th>
                                                            <th>Total Deduction(Kg)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForCustomerLeafCollectionReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan="5" style={{ textAlign: "left" }}> Total </th>
                                                            <th style={{ textAlign: "right" }}>{totalValues.bagcount}</th>
                                                            <th style={{ textAlign: "right" }}>{totalValues.net.toFixed(2)}</th>
                                                            <th style={{ textAlign: "right" }}>{totalValues.gross.toFixed(2)}</th>
                                                            <th style={{ textAlign: "right" }}>{totalValues.deduction.toFixed(2)}</th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Customer Leaf Collection Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} totalValues={totalValues}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys}
                                            totalAmount={totalAmount} customerCount={customerCount} totalAmountOfLeaf={totalAmountOfLeaf}
                                            bagCount={bagCount} totalBagCount={totalBagCount} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
